export class ServerRootDetector {
    private static _instance: ServerRootDetector;

    static getInstance(): ServerRootDetector {
        if (!ServerRootDetector._instance) {
            ServerRootDetector._instance = new ServerRootDetector();
        }
        return ServerRootDetector._instance;
    }

    private _baseRoot: string;
    private _assetsPath: string;
    private _customPagesSitePath: string;
    private _timelineSitePath: string;

    private constructor() {
        this.reload();
    }

    getResourceRoot() {
        return this._baseRoot + 'Client/api';
    }

    getAuthRoot() {
        return this._baseRoot + 'oauth2';
    }

    getAssetsRoot() {
        return this._assetsPath;
    }

    getBaseRoot() {
        return this._baseRoot;
    }

    getCustomPagesSiteRoot() {
        return this._customPagesSitePath;
    }

    getTimelineSiteRoot () {
        return this._timelineSitePath;
    }

    reload() {
        this._baseRoot = window['restServiceBaseUrl'] ?? location.origin + '/Estensa.Rest/';
        this._assetsPath = window['assetsBaseUrl'] ?? location.origin + '/suitestensa/assets/';
        this._customPagesSitePath = window['customPagesSitePath'] ?? location.origin + '/CustomPages/';
        this._timelineSitePath = window['timelineSitePath'] ?? location.origin + '/Timeline/';
    }
}
